import React from "react";
import {
  FaUndo,
  FaTruck,
  FaShieldAlt,
  FaPhoneAlt,
  FaCheckCircle,
} from "react-icons/fa";

const ReturnPolicy = () => {

  const sections = [
    "Cancellation Policy",
    "Return Policy",
    "Warranty",
    "Buyback Program",
    "Return Conditions",
    "Non-Returnable",
    "Refund Process",
    "Quality Check",
    "Policy Updates",
    "Contact Us",
  ];

  return (
    <div className="bg-[#f5f7fb] min-h-screen py-10 px-4">

      <div className="max-w-7xl mx-auto grid md:grid-cols-[250px,1fr] gap-6">

        {/* 🔥 SIDEBAR */}
        <div className="hidden md:block sticky top-24 h-fit bg-white rounded-xl shadow p-4">
          <h3 className="font-semibold mb-3">Quick Links</h3>

          <div className="flex flex-col gap-2 text-sm">
            {sections.map((sec) => (
              <a
                key={sec}
                href={`#${sec}`}
                className="text-gray-600 hover:text-black transition"
              >
                {sec}
              </a>
            ))}
          </div>
        </div>

        {/* 🔥 MAIN CONTENT */}
        <div className="bg-white rounded-2xl shadow-lg p-6 md:p-10">

          <h1 className="text-2xl md:text-3xl font-bold mb-2">
            Cancellation & Return Policy
          </h1>

          <p className="text-sm text-gray-500 mb-6">
            Last Updated: 2026
          </p>

          <p className="text-gray-700 mb-8 leading-relaxed">
            At <b>LappyShop</b>, we ensure quality refurbished laptops with complete transparency and support.
          </p>

          {/* 🔥 SECTIONS */}

          <Section
            id="Cancellation Policy"
            icon={<FaUndo />}
            title="Cancellation Policy"
            items={[
              "Cancel before shipping",
              "₹500 payment deduction",
              "After dispatch → shipping charges apply",
            ]}
          />

          <Section
            id="Return Policy"
            icon={<FaTruck />}
            title="14-Day Return Policy"
            items={[
              "Defective or wrong product",
              "Missing accessories",
              "Quality issues",
            ]}
          />

          <Section
            id="Warranty"
            icon={<FaShieldAlt />}
            title="Warranty"
            items={[
              "Up to 1 year warranty",
              "6 months battery warranty",
              "No physical damage coverage",
            ]}
          />

          <Section
            id="Buyback Program"
            title="Buyback Program"
            text="Return anytime with depreciation (min 5% per month)."
          />

          <Section
            id="Return Conditions"
            title="Return Conditions"
            items={[
              "Original condition required",
              "All accessories included",
              "No personal data",
            ]}
          />

          <Section
            id="Non-Returnable"
            title="Non-Returnable Cases"
            items={[
              "Physical damage",
              "Customized products",
              "Misuse",
            ]}
          />

          <Section
            id="Refund Process"
            title="Refund Process"
            items={[
              "24–48 hrs initiation",
              "7–14 days credit",
              "Original payment method",
            ]}
          />

          <Section
            id="Quality Check"
            title="Quality Check"
            text="All devices undergo strict testing before delivery."
          />

          <Section
            id="Policy Updates"
            title="Policy Updates"
            text="We may update policies anytime."
          />

          <Section
            id="Contact Us"
            icon={<FaPhoneAlt />}
            title="Contact Us"
            text={
              <>
                📧 support@lappyshop.com <br />
                📞 +91-9560205329 <br />
                🌐 www.lappyshop.com
              </>
            }
          />

        </div>

      </div>

    </div>
  );
};

export default ReturnPolicy;





// 🔥 FIXED SECTION COMPONENT (SAFE VERSION)
const Section = ({ id, title, items, text, icon }) => {
  return (
    <div id={id} className="mb-8 scroll-mt-24">

      <div className="flex items-center gap-2 mb-2">
        {icon && <span className="text-green-600">{icon}</span>}
        <h2 className="text-lg md:text-xl font-semibold">
          {title}
        </h2>
      </div>

      <div className="bg-gray-50 p-4 rounded-xl text-gray-700 text-sm leading-relaxed">

        {/* ✅ LIST */}
        {items && (
          <ul className="space-y-2">
            {items.map((item, i) => (
              <li key={i} className="flex items-center gap-2">
                <FaCheckCircle className="text-green-500 text-xs" />
                {item}
              </li>
            ))}
          </ul>
        )}

        {/* ✅ TEXT */}
        {text && <div>{text}</div>}

      </div>

    </div>
  );
};